/**
 * User: WangMeng
 * Date: 2018-04-09
 * Time: 18:07
 * Desc: 上市公司财务情况概览----公司排名情况
 */
import styles from './company.scss';
import React, { PureComponent } from 'react';
import { Col, Row, Spin } from 'antd';
import { numberFixed } from '../../../../utils/formatter';
import {getChildOptions, keyToText} from '../../../../utils/util';
import NoData from '../../../common/noData/NoData';
import ScoresRanking from '../../../common/scoresRanking/ScoresRanking';
import SearchForm from './common/SearchForm';
import { getComRank, getComVaryRank } from '../../../../services/regulatoryStatistical';

export default class Company extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            searchParams: {},
            rankLoading: true,
            varyRankLoading: true,
            statisticText: '',
            subStatisticText: '',
            rankData: [],
            varyRankData: []
        };
    }

    resetLoading = () => {
        this.setState({
            rankLoading: false,
            varyRankLoading: false
        });
    };

    onSearch = (searchParams) => {
        const { options } = this.props;
        const { statisticType, subStatisticType } = searchParams;
        this.setState({
            selectedIndustry: {},
            searchParams,
            statisticText: keyToText(statisticType, options.riskFakeTypes),
            subStatisticText: keyToText(subStatisticType, getChildOptions(statisticType, options.riskFakeTypes))
        }, () => {
            this.getRankData();
            this.getVaryRankData();
        });
    };

    // 分数排名
    getRankData = () => {
        const { searchParams } = this.state;
        this.setState({
            rankLoading: true
        });
        getComRank(searchParams).then((data) => {
            data = data || [];
            this.setState({
                rankData: this.formatData(data),
                rankLoading: false
            });
        }).catch(() => {
            this.setState({
                rankData: [],
                rankLoading: false
            });
        });
    };

    // 上升排名
    getVaryRankData = () => {
        const { searchParams } = this.state;

        this.setState({
            varyRankLoading: true
        });
        getComVaryRank(searchParams).then((data) => {
            data = data || [];
            this.setState({
                varyRankData: this.formatData(data),
                varyRankLoading: false
            });
        }).catch(() => {
            this.setState({
                varyRankData: [],
                varyRankLoading: false
            });
        });
    };

    formatData = (data) => {
        data.forEach((d) => {
            d.name = d.sesName;
            d.value = numberFixed(d.tScore);
        });
        return data;
    };

    varyExtra = (d) => {
        return `涨幅${d.increase}`;
    };

    render() {
        const { options } = this.props;
        const { rankLoading, varyRankLoading, rankData, varyRankData, statisticText } = this.state;

        return (
            <div>
                <SearchForm showSubType={true} options={options} onSearch={this.onSearch} onFail={this.resetLoading}/>
                <Row className={styles.sortRow}>
                    <Col span={13}>
                        <p className="wrap-title">{statisticText}公司TOP10</p>
                        {
                            rankLoading ?
                                <Spin /> :
                                rankData.length ?
                                    <ScoresRanking className={styles.sortList} data={rankData} /> :
                                    <NoData />
                        }
                    </Col>
                    <Col span={11}>
                        <p className="wrap-title">{statisticText}公司上升TOP10</p>
                        {
                            varyRankLoading ?
                                <Spin /> :
                                varyRankData.length ?
                                    <ScoresRanking className={styles.sortList} data={varyRankData} extra={this.varyExtra}/> :
                                    <NoData />
                        }
                    </Col>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/financialOverview/Company.jsx